import React from 'react'

function EventsListsList({ color, bgColor }) {
    return (
        <>
            <svg width="24" height="25" viewBox="0 0 24 25" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6H12.5" stroke={color} stroke-linecap="round" />
                <path d="M3 12.5H12.5" stroke={color} stroke-linecap="round" />
                <path d="M3 19H12.5" stroke={color} stroke-linecap="round" />
                <path d="M21 19H16M17 21.5L20 16.5M20 21.5L17 16.5" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
                <path d="M21 6H16M17 8.5L20 3.5M20 8.5L17 3.5" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    )
}

export default EventsListsList